import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ModLocServiciiService } from '../mod-loc-servicii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ModulLocatiiServiciiActive, ModulLocatiiServiciiActiveUpdate } from '../mod-loc-servicii.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { ServiciiService } from '../../servicii/servicii.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-edit-mod-loc-servicii',
    templateUrl: './edit-mod-loc-servicii.component.html',
    styleUrls: ['./edit-mod-loc-servicii.component.scss']
})
export class EditModLocServiciiComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    module!: any[];
    locatii!: any[];
    servicii!: any[];
    users!: any[];

    form: FormGroup = new FormGroup({
        id_modul: new FormControl(this.data.id_modul, [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl(this.data.id_locatie, [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl(this.data.id_serviciu, [Validators.required, notDefaultValidator('-1')]),
        id_user: new FormControl(this.data.id_user, [Validators.required, notDefaultValidator('-1')]),
        email_to_reports: new FormControl(this.data.email_to_reports, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditModLocServiciiComponent>,
        private moduleLocatiiServiciiActiveService: ModLocServiciiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService,
        private commonService: CommonService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadUsersGhiseu();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.moduleLocatiiServiciiActiveService.setToken(token);
        });
    }

    loadUsersGhiseu() {
        this.isLoading = true;
        this.commonService.getUsersGhiseu().pipe(
            map((results: any) => [...results]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.users = res;
            },
            error: (err) => {
                console.error('Error in get users ghiseu unic: ', err);
            }
        })
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie, id_serviciu, id_user, email_to_reports } = this.form.value as ModulLocatiiServiciiActive;

        const updatedModulLocatiiServiciiActive: ModulLocatiiServiciiActiveUpdate = {
            id_modul,
            id_locatie,
            id_serviciu,
            id_user,
            email_to_reports,
            id: this.data.id,
        };

        this.moduleLocatiiServiciiActiveService
            .updateModulLocatiiServicii(updatedModulLocatiiServiciiActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
